module.exports = __webpack_public_path__ + "img/light-fm-Path 42 Copy@3x.dbf798f7.png";